import React from "react";
import theme from "storybook-styles/theme";
import { FinalCta } from "storybook-components/FinalCta";
import Layout from "../components/Layout";
import HubHero from "../components/ResourcesHub/HubHero";
import TutorialCards from "../components/ResourcesHub/TutorialCards";
import MoreOutOfModeCards from "../components/ResourcesHub/MoreOutOfModeCards";
import SupportCards from "../components/ResourcesHub/SupportCards";
import HubCardSection from "../components/ResourcesHub/HubCardSection";
import { RESOURCE_MAIN_LINKS } from "../hub-links";
import SeoHelmet from "../components/SeoHelmet";

const IndexPage = () => {
  return (
    <Layout fluid hideDefaultCta backgroundColor={theme.colors.green5}>
      <SeoHelmet ogtype="website" isLandingPage />
      <HubHero />
      <HubCardSection links={RESOURCE_MAIN_LINKS} />
      <MoreOutOfModeCards />
      <TutorialCards />
      <SupportCards />
      <FinalCta />
    </Layout>
  );
};

export default IndexPage;
